import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Layout } from './components/Layout'
import { PrivateRoute } from './router/PrivateRoute'
import { FormBuilder } from './views/FormBuilder'
import { LoginPage } from './views/Login'
import { Responses } from './views/Responses'
import { SurveyList } from './views/SurveyList'

function App() {
  return (
    <Switch>
      <Route path="/login">
        <Layout centered>
          <LoginPage />
        </Layout>
      </Route>
      <PrivateRoute path="/surveys/:surveyId">
        <Layout>
          <FormBuilder />
        </Layout>
      </PrivateRoute>
      <PrivateRoute path="/surveys">
        <Layout>
          <SurveyList />
        </Layout>
      </PrivateRoute>
      <PrivateRoute path="/responses/:surveyId">
        <Layout>
          <Responses />
        </Layout>
      </PrivateRoute>
      <PrivateRoute path="/">
        <Layout>
          <SurveyList />
        </Layout>
      </PrivateRoute>
    </Switch>
  )
}

export default App
